import addToGlobalStore, { getStore } from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";

import globalMessaging from "ducks/global_messaging";
import globalMessagingAnalytics from "analytics/global_messaging";

// Store with global messaging state.
// Export this so the HoC can use the same store, too.
export default function initializeStore() {
	const store = getStore();

	if (!store || !store.globalMessaging) {
		const updatedStore = addToGlobalStore({ globalMessaging });
		addToGlobalAnalyticsMiddleware({ globalMessaging: globalMessagingAnalytics });

		return updatedStore;
	}

	return store;
}



// WEBPACK FOOTER //
// ./src/apps/messenger/store.js